export default __webpack_public_path__ + "static/media/ic_phone.0a9b38f2.png";